/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`En esta sección vamos a explorar como renderizar componentes dependiendo del estado en nuestra aplicación.`}</p>
    <p>{`Como recordarás, en esta sección creamos estados de carga y error que le pasamos a `}<inlineCode parentName="p">{`<PokedexScreen/>`}</inlineCode>{`. Esto lo utilizaremos para que la pantalla luzca diferente si está buscando un Pokémon, si lo ha encontrado o si ha ocurrido algún error.`}</p>
    <p>{`En realidad existen librerías especializadas para manejar los estados de las peticiones a una API, aquí lo haremos utilizando el estado, ya que el objetivo era crear una aplicación sencilla, pero donde utilizáramos la mayoría de las piezas básicas de una aplicación moderna.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;